import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IAvailableSeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';

import SlideCarousel from '@r1-frontend/ui-react/components/SlideCarousel';
import { TInfoBlockData } from '@r1-frontend/ui-react/organisms/ToggleCard/types';

import InfoHint from '~/src/features/payments-abn/components/InfoHint';
import SeasonTicket from '~/src/features/payments-abn/components/SeasonTicketPayment/components/Ticket';
import { useSlider } from '~/src/features/payments-abn/components/SeasonTicketPayment/hooks/useSlider';
import { useTicketHint } from '~/src/features/payments-abn/components/SeasonTicketPayment/hooks/useTicketHint';
import { updateSeasonTicket } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import { TState } from '~/src/store';

import * as ST from './styled';

interface IProps {
    selectedTicket?: IAvailableSeasonTicket,
    tickets: IAvailableSeasonTicket[],
}

const TicketsList = ({
    selectedTicket,
    tickets,
}: IProps): JSX.Element => {
    const dispatch = useDispatch();

    const { seasonTicket } = useSelector((state: TState) => state.seasonTicketPayment);
    const { id: selectedTicketId } = seasonTicket || {};

    const { isSlider, slideWidth = 190, slideHeight, cellSpacing = 0 } = useSlider();

    const hintData = useTicketHint();

    const onSelectTicket = (id: TInfoBlockData['id']) => {
        const ticketById = tickets.find(flag => flag.id === id);

        if (ticketById && id !== selectedTicketId) {
            dispatch(updateSeasonTicket(ticketById));
        }
    };

    const renderTickets = () => tickets.map(ticket => (
        <SeasonTicket
            key={ticket.id}
            isActive={ticket.id === selectedTicket?.id}
            ticket={ticket}
            onSelect={onSelectTicket}
        />
    ));

    const slideIndex = useMemo(() => tickets.findIndex(ticket => ticket.id === selectedTicket?.id), [selectedTicket, tickets]);

    return (
        <ST.Content>
            {isSlider
                ? <SlideCarousel
                    withoutArrows={true}
                    withoutDots={true}
                    slideIndex={slideIndex}
                    slideWidth={slideWidth}
                    initialSlideHeight={slideHeight}
                    cellSpacing={cellSpacing}
                >
                    {renderTickets()}
                </SlideCarousel>
                : <ST.ListWrapper>{renderTickets()}</ST.ListWrapper>
            }
            <InfoHint {...hintData}/>
        </ST.Content>
    );
};

export default TicketsList;
